import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { fmtDateTime } from "@/lib/helpers";
import { PlayCircle, RotateCcw, Trash2 } from "lucide-react";

// Super Admin : espaces de démonstration (un par visiteur, 24 h), remise à zéro ciblée et purge des expirés.
export function DemoSandboxes() {
  const [d, setD] = useState(null);
  const load = () => api.get("/super/demo-sandboxes").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const act = async (fn, ok) => { try { await fn(); toast.success(ok); load(); } catch (e) { toast.error(apiError(e.response?.data?.detail) || e.message); } };
  if (!d) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="demo-sandboxes">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2"><PlayCircle className="w-5 h-5 text-accent-600" /><h2 className="font-heading font-bold text-brand-900">Démonstrations</h2>
          <span className="text-sm text-slate-500" data-testid="demo-active-count">{d.active} espace(s) actif(s) · expiration {d.ttl_hours} h</span></div>
        <Button variant="outline" size="sm" data-testid="demo-purge-expired" onClick={() => act(() => api.post("/super/demo-sandboxes/purge-expired"), "Démos expirées supprimées")}><Trash2 className="w-4 h-4 mr-1" />Nettoyer les expirées</Button>
      </div>
      <div className="mt-3 max-h-56 overflow-y-auto divide-y divide-slate-100">
        {d.sandboxes.map((s) => (
          <div key={s.id} className="flex items-center justify-between py-2 text-sm" data-testid={`demo-sandbox-${s.code}`}>
            <span><b>{s.code}</b> · créée {fmtDateTime(s.created_at)} · {s.expired ? <span className="text-red-600">expirée</span> : `expire ${fmtDateTime(s.demo_expires_at)}`}</span>
            <Button variant="ghost" size="sm" data-testid={`demo-reset-${s.code}`} onClick={() => window.confirm(`Supprimer l'espace ${s.code} ? Le visiteur repartira d'une démo vierge.`) && act(() => api.delete(`/super/demo-sandboxes/${s.id}`), "Espace de démo réinitialisé")}><RotateCcw className="w-4 h-4 mr-1" />Réinitialiser</Button>
          </div>
        ))}
        {d.sandboxes.length === 0 && <p className="text-sm text-slate-400 py-3">Aucun espace de démonstration.</p>}
      </div>
    </div>
  );
}
